import type { ThemeConfig } from 'antd';

const brand = {
  lime: '#C6F221',
  limeDark: '#9BBD0A',
  violet: '#7C3AED',
  violetLight: '#A78BFA',
  orange: '#F97316',
  sidebar: '#1a1a2e',
} as const;

export const lightTheme: ThemeConfig = {
  token: {
    colorPrimary: brand.limeDark,
    colorSuccess: '#10b981',
    colorWarning: brand.orange,
    colorError: '#ef4444',
    colorInfo: '#06b6d4',
    colorBgBase: '#f8f9fc',
    colorBgContainer: '#ffffff',
    colorBgLayout: '#f0f2f5',
    colorText: '#0f0f12',
    colorTextSecondary: '#52525b',
    colorTextTertiary: '#a1a1aa',
    colorBorder: '#e4e4e7',
    colorBorderSecondary: '#e8e8e8',
    borderRadius: 8,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 14,
    controlHeight: 40,
  },
  components: {
    Button: {
      borderRadius: 10,
      fontWeight: 600,
      controlHeight: 42,
      controlHeightSM: 34,
      controlHeightLG: 50,
    },
    Input: {
      borderRadius: 10,
    },
    Card: {
      borderRadiusLG: 12,
    },
    Table: {
      headerBg: '#fafafa',
      headerColor: '#888888',
      rowHoverBg: '#fafcff',
      borderColor: '#f0f0f0',
      cellPaddingBlock: 11,
      cellPaddingInline: 16,
      headerSplitColor: 'transparent',
    },
    Tag: {
      borderRadiusSM: 4,
    },
    Menu: {
      darkItemBg: brand.sidebar,
      darkSubMenuItemBg: brand.sidebar,
      darkItemColor: 'rgba(255,255,255,0.55)',
      darkItemHoverColor: 'rgba(255,255,255,0.85)',
      darkItemHoverBg: 'rgba(255,255,255,0.05)',
      darkItemSelectedBg: 'rgba(255,255,255,0.1)',
      darkItemSelectedColor: '#ffffff',
      itemHeight: 38,
      iconSize: 16,
    },
    Layout: {
      siderBg: brand.sidebar,
      headerBg: '#ffffff',
      bodyBg: '#f0f2f5',
    },
  },
};

